import api from './api';

const store = (token, password) => api.post(`/reset`, { token, password });

export default { store };
